import { useId, type ReactNode } from "react";
import { Card } from "@mmm/ui";
interface DashboardPanelProps {
  title: ReactNode;
  subtitle?: ReactNode;
  toolbar?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}

/** Shared fixed-header panel with a keyboard-scrollable content area. */
export function DashboardPanel({
  title,
  subtitle,
  toolbar,
  children,
  className = "",
  bodyClassName = "",
}: DashboardPanelProps) {
  const titleId = useId();
  return (
    <Card as="section" padding="none" className={`mmm-dashboard-panel ${className}`.trim()}>
      <header className="mmm-dashboard-panel-head">
        <div>
          <h2 id={titleId}>{title}</h2>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {toolbar}
      </header>
      <div
        className={`mmm-dashboard-panel-body ${bodyClassName}`.trim()}
        role="region"
        aria-labelledby={titleId}
        tabIndex={0}
      >
        {children}
      </div>
    </Card>
  );
}
